import { ApexOptions } from "apexcharts";
import { ChartOptionType, InterFaceCommonSocialCharts } from "../../../Type/WidgetsType";
import { ArrowDownRight } from "react-feather";

const primary = "var(--theme-deafult)" ;

export const CURRANCES_DATA = [
  {
    title: "Bitcoin",
    sortName: "BTC",
    icon: "beta",
    color: "warning",
    price: "21,43",
    gros: 50,
    chart: {
      color: ["#FFA941"],
      label: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov"],
      series: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
    },
  },
  {
    title: "Ethereum",
    sortName: "ETC",
    icon: "eth",
    color: "primary",
    price: "7,450",
    gros: 35,
    chart: {
      color: ["var(--theme-deafult)"],
      label: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov"],
      series: [30, 25, 30, 25, 64, 40, 59, 52, 64],
    },
  },
  {
    title: "Leave Travel",
    sortName: "LTC",
    icon: "ltc",
    color: "success",
    price: "2,198",
    gros: 73,
    chart: {
      color: ["#54BA4A"],
      label: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov"],
      series: [30, 25, 36, 30, 64, 50, 45, 62, 60, 64],
    },
  },
];

export const WIDGET_LINE_CHART: ApexOptions = {
  chart: {
    width: 100,
    height: 120,
    type: "line",
    toolbar: {
      show: false,
    },
    offsetY: -15,
    dropShadow: {
      enabled: true,
      enabledOnSeries: undefined,
      top: 6,
      left: 0,
      blur: 6,
      color: "",
      opacity: 0.3,
    },
  },
  grid: {
    show: false,
  },
  colors: [],
  stroke: {
    width: 2,
    curve: "smooth",
  },
  markers: {
    size: 0,
  },
  xaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    marker: {
      show: false,
    },
    x: {
      show: false,
    },
  },
  responsive: [
    {
      breakpoint: 1790,
      options: {
        chart: {
          width: 100,
          height: 100,
        },
      },
    },
    {
      breakpoint: 1661,
      options: {
        chart: {
          width: "100%",
          height: 100,
        },
      },
    },
  ],
};

export const RADIAL_PROGRESS_DATA = [
  {
    title: "Average Sales Per Day",
    average: "45,908",
    gros: 5.7,
    color: "primary",
    subTitle: "The point of using Lorem Ipsum",
    chart: {
      series: [70],
      color: "var(--theme-default)",
    },
  },
  {
    title: "Average Profit Per Day",
    average: "89.6%",
    gros: 5.7,
    color: "primary",
    subTitle: "The point of using Lorem Ipsum",
    chart: {
      series: [60],
      color: "var(--theme-secondary)",
    },
  },
];

export const WIDGET_RADIAL_CHART: ApexOptions = {
  chart: {
    height: 130,
    type: "radialBar",
    dropShadow: {
      enabled: true,
      top: 3,
      left: 0,
      blur: 10,
      color: "",
      opacity: 0.35,
    },
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: "60%",
      },
      track: {
        strokeWidth: "45%",
        opacity: 1,
        margin: 5,
      },
      dataLabels: {
        value: {
          color: "var(--body-font-color)",
          fontSize: "14px",
          show: true,
          offsetY: -10,
        },
      },
    },
  },
  colors: [],
  stroke: {
    lineCap: "round",
  },
  responsive: [
    {
      breakpoint: 1500,
      options: {
        chart: {
          height: 130,
        },
      },
    },
  ],
};

export const SALE_REPORT_DATA = [
  {
    title: "Purchase",
    gros: 50,
    total: 10_000,
    color: "secondary",
    icon: "cart",
  },
  {
    title: "Sales return",
    gros: 20,
    total: 7000,
    color: "warning",
    icon: "return-box",
  },
  {
    title: "Sales",
    gros: 70,
    total: 4_200,
    color: "primary",
    icon: "tag",
  },
  {
    title: "Purchase rate",
    gros: 70,
    total: 5700,
    color: "success",
    icon: "rate",
  },
];

export const COURSE_BOX_DATA = [
  {
    title: "Completed Courses",
    course: "100+",
    icon: "course-1",
    link: "View course",
  },
  {
    title: "In Progress Courses",
    course: "50+",
    icon: "course-2",
    link: "View course",
    color: "warning",
  },
];

export const SQUARE_GROUP_DATA = ["square-1 warning", "square-1 primary", "square-2 warning1", "square-3 danger", "square-4 light", "square-5 warning", "square-6 success", "square-6 success"];

export const GROW_CHART_DATA: ChartOptionType = {
  series: [
    {
      name: "Growth",
      data: [10, 5, 15, 0, 15, 12, 29, 29, 29, 12, 15, 5],
    },
  ],
  options: {
    chart: {
      height: 135,
      type: "line",
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        enabledOnSeries: undefined,
        top: 5,
        left: 0,
        blur: 4,
        color: "#7366ff",
        opacity: 0.22,
      },
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    colors: ["#5527FF"],
    stroke: {
      width: 3,
      curve: "smooth",
    },
    xaxis: {
      type: "category",
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
      tickAmount: 10,
      labels: {
        style: {
          fontFamily: "Rubik, sans-serif",
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        gradientToColors: ["#5527FF"],
        shadeIntensity: 1,
        type: "horizontal",
        opacityFrom: 1,
        opacityTo: 1,
        colorStops: [
          {
            offset: 0,
            color: "#5527FF",
            opacity: 1,
          },
          {
            offset: 100,
            color: "#E069AE",
            opacity: 1,
          },
        ],
      },
    },
    yaxis: {
      min: -10,
      max: 40,
      labels: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 992,
        options: {
          chart: {
            height: 150,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            height: 180,
          },
        },
      },
    ],
  },
};

// visitor chart
export const VISITOR_CARD_OPTION: ApexOptions = {
  series: [
    {
      name: "Active",
      data: [18, 10, 65, 18, 28, 10],
    },
    {
      name: "Bounce",
      data: [25, 50, 30, 30, 25, 45],
    },
  ],
  chart: {
    type: "bar",
    height: 270,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "50%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 6,
    colors: ["transparent"],
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: ["#FFA941", "var(--theme-default)"],
  xaxis: {
    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    tickAmount: 4,
    tickPlacement: "between",
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 5,
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
    horizontalAlign: "left",
    fontFamily: "Rubik, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    labels: {
      colors: "var(--chart-text-color)",
    },
    itemMargin: {
      horizontal: 10,
    },
  },
  responsive: [
    {
      breakpoint: 1366,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "80%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "60%",
          },
        },
        grid: {
          padding: {
            right: 5,
          },
        },
      },
    },
  ],
};

export const DAILY_DROPDOWN: string[] = ["Today", "Tomorrow", "Yesterday"];

// radial chart js
export const radialCommonOption = (data: InterFaceCommonSocialCharts) => {
  return {
    series: data.radialYseries,
    options: {
      chart: {
        height: 130,
        type: "radialBar",
        dropShadow: {
          enabled: true,
          top: 3,
          left: 0,
          blur: 10,
          color: data.dropshadowColor,
          opacity: 0.35,
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "60%",
          },
          track: {
            strokeWidth: "60%",
            opacity: 1,
            margin: 5,
          },
          dataLabels: {
            showOn: "always",
            value: {
              color: "var(--body-font-color)",
              fontSize: "14px",
              show: true,
              offsetY: -10,
            },
          },
        },
      },
      colors: data.color,
      stroke: {
        lineCap: "round",
      },
      responsive: [
        {
          breakpoint: 1500,
          options: {
            chart: {
              height: 130,
            },
          },
        },
      ],
    },
  };
};

const radial1 = {
  color: ["var(--theme-deafult)"],
  dropshadowColor: "var(--theme-deafult)",
  radialYseries: [78],
};

const radial2 = {
  color: ["#57B9F6"],
  dropshadowColor: "#FFA941",
  radialYseries: [50],
};

const radial3 = {
  color: ["#FFA941"],
  dropshadowColor: "#57B9F6",
  radialYseries: [70],
};

const radial4 = {
  color: ["#FF3364"],
  dropshadowColor: "#FF3364",
  radialYseries: [80],
};

export const SOCIAL_DATA_WIDGET = [
  {
    title: "Facebook",
    image: "1.png",
    gros: 22.9,
    total: 12_098,
    subTitle: "Followers",
    status: "success",
    chartData: radialCommonOption(radial1),
  },
  {
    title: "Instagram",
    image: "2.png",
    gros: 27.4,
    total: 15_080,
    subTitle: "Followers",
    status: "success",
    chartData: radialCommonOption(radial2),
  },
  {
    title: "Twitter",
    image: "3.png",
    gros: 14.09,
    total: 12_564,
    subTitle: "Followers",
    status: "success",
    chartData: radialCommonOption(radial3),
  },
  {
    title: "Youtube",
    image: "4.png",
    gros: 14.09,
    total: 68_954,
    subTitle: "Followers",
    status: "secondary",
    chartData: radialCommonOption(radial4),
  },
];

export const SMALL_WIDGET_DATA = [
  {
    title: "New Orders",
    color: "primary",
    total: 2_435,
    gros: 50,
    icon: "new-order",
  },
  {
    title: "New Customers",
    color: "warning",
    total: 2_908,
    gros: 20,
    icon: "customers",
  },
  {
    title: "Average Sale",
    color: "secondary",
    total: 389,
    gros: 10,
    prefix: "$",
    icon: "sale",
    suffix: "k",
  },
  {
    title: "Gross Profit",
    color: "success",
    total: 3_908,
    gros: 80,
    prefix: "$",
    icon: "profit",
  },
];

// order chart
export const ORDER_OPTIONS: ApexOptions = {
  series: [
    {
      name: "Daily",
      data: [2.15, 3, 1.5, 2, 2.4, 3, 2.4, 2.8, 1.5, 1.7, 3, 2.5, 3, 2, 2.15, 3, 1.1],
    },
    {
      name: "Weekly",
      data: [-2.15, -3, -1.5, -2, -2.4, -3, -2.4, -2.8, -1.5, -1.7, -3, -2.5, -3, -2, -2.15, -3, -1.1],
    },
    {
      name: "Monthly",
      data: [-2.25, -2.35, -2.45, -2.55, -2.65, -2.75, -2.85, -2.95, -3.0, -3.1, -3.2, -3.25, -3.1, -3.0, -2.95, -2.85, -2.75],
    },
    {
      name: "Yearly",
      data: [2.25, 2.35, 2.45, 2.55, 2.65, 2.75, 2.85, 2.95, 3.0, 3.1, 3.2, 3.25, 3.1, 3.0, 2.95, 2.85, 2.75],
    },
  ],
  chart: {
    type: "bar",
    width: 180,
    height: 120,
    offsetY: -13,
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40%",
      barHeight: "80%",
    },
  },
  colors: [primary, primary, "#F2F3F7", "#F2F3F7"],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    width: 0,
  },
  legend: {
    show: false,
  },
  grid: {
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  yaxis: {
    min: -5,
    max: 5,
    show: false,
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  tooltip: {
    shared: false,
    x: {
      show: false,
    },
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
    offsetX: 0,
    offsetY: 0,
    labels: {
      offsetX: 0,
      offsetY: 0,
      show: false,
    },
    axisBorder: {
      offsetX: 0,
      offsetY: 0,
      show: false,
    },
    axisTicks: {
      offsetX: 0,
      offsetY: 0,
      show: false,
    },
  },
  responsive: [
    {
      breakpoint: 1760,
      options: {
        chart: {
          width: 160,
        },
      },
    },
    {
      breakpoint: 1601,
      options: {
        chart: {
          height: 110,
        },
      },
    },
    {
      breakpoint: 1560,
      options: {
        chart: {
          width: 140,
        },
      },
    },
    {
      breakpoint: 1460,
      options: {
        chart: {
          width: 120,
        },
      },
    },
    {
      breakpoint: 1400,
      options: {
        chart: {
          width: 290,
        },
      },
    },
    {
      breakpoint: 1110,
      options: {
        chart: {
          width: 200,
        },
      },
    },
    {
      breakpoint: 700,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        chart: {
          width: 220,
        },
      },
    },
    {
      breakpoint: 420,
      options: {
        chart: {
          width: 150,
        },
      },
    },
  ],
};

// profit chart
export const PROFIT_OPTION: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [210, 180, 650, 200, 600, 100, 800, 300, 500],
    },
  ],
  chart: {
    width: 200,
    height: 150,
    type: "line",
    offsetY: -24,
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      enabledOnSeries: undefined,
      top: 5,
      left: 0,
      blur: 3,
      color: "#16C7F9",
      opacity: 0.3,
    },
    zoom: {
      enabled: false,
    },
  },
  colors: ["#16C7F9"],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    width: 2,
    curve: "smooth",
  },
  grid: {
    show: false,
  },
  tooltip: {
    x: {
      show: false,
    },
    marker: {
      show: false,
    },
  },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  responsive: [
    {
      breakpoint: 1780,
      options: {
        chart: {
          width: 180,
        },
      },
    },
    {
      breakpoint: 1680,
      options: {
        chart: {
          width: 160,
        },
      },
    },
    {
      breakpoint: 1601,
      options: {
        chart: {
          height: 110,
        },
      },
    },
    {
      breakpoint: 1560,
      options: {
        chart: {
          width: 140,
        },
      },
    },
    {
      breakpoint: 1460,
      options: {
        chart: {
          width: 120,
        },
      },
    },
    {
      breakpoint: 1400,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 1110,
      options: {
        chart: {
          width: 200,
        },
      },
    },
    {
      breakpoint: 700,
      options: {
        chart: {
          width: 150,
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        chart: {
          width: 220,
        },
      },
    },
    {
      breakpoint: 420,
      options: {
        chart: {
          width: 150,
        },
      },
    },
  ],
};

export const WIDGET_WITH_CART_DATA = [
  { amount: "1,80k", tittle: "Orders", chartOption: ORDER_OPTIONS },
  { amount: "6,90k", tittle: "Profit", chartOption: PROFIT_OPTION },
];

export const BALANCE_LIST_DATA = [
  {
    color: "danger",
    icon: <ArrowDownRight />,
    spanText: "Investment",
    title: "78.8K",
    badge: "-11.67%",
  },
  {
    color: "success",
    icon: <ArrowDownRight />,
    spanText: "Cash Back",
    title: "19.7K",
    badge: "+10.67%",
  },
];